<template>
  <div class="trun-role">
    <div class="page-handle">
      <div class="left">
        <!-- v-auth="'aaaa'"  -->
        <a-button v-auth="'10005'" type="primary" @click="ckBaseDataModel">添加跟踪状态</a-button>
      </div>
      <div class="right">
        <a-input-search @search="onSearch" placeholder="请输入状态标识" style="width: 200px" />
      </div>
    </div>
    <div class="page-content page-turn-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :dataSource="data"
        :rowKey="record => record.id"
        class="hospital-table"
        size="middle"
      >
        <span slot="number" slot-scope="text,record,index">{{(page-1)*pageSize+index+1}}</span>
        <span slot="handleslot" slot-scope="text,record">
          <span v-auth="'10006'" v-if="!record.isSystem" @click="editbaseModel(record)" class="link">编辑</span>
          <span v-auth="'10007'" v-if="!record.isSystem" style="margin:0 10px;color:#428EF7;">|</span>
          <span v-auth="'10007'" v-if="!record.isSystem" @click="deleteBaseData(record)" class="link">删除</span>
        </span>
      </a-table>
    </div>
    <div class="pagination">
      <a-pagination
        @change="pageChange"
        :pageSize.sync="pageSize"
        v-model="page"
        size="small"
        :total="baseData.total"
      />
    </div>
    <page-model @close="closeModel" :visible="visible">
      <base-data-add :baseData="selectData" v-if="visible" @close="closeModel"></base-data-add>
    </page-model>
    <h-confirm
      :visible="confirmVisible"
      @close="closeConfirm"
      @ok="okClick"
      :loadding.sync="confirmLoadding"
      :title="currentConfirmData.title"
      :content="currentConfirmData.content"
      :desc="currentConfirmData.desc"
    ></h-confirm>
  </div>
</template>

<script>
import BaseDataAdd from "./baseDataAdd.vue";

const columns = [
  {
    title: "序号",
    scopedSlots: { customRender: "number" }
  },
  {
    title: "大类",
    dataIndex: "bigClassifyOperateStatusRemark"
  },
  {
    title: "小类",
    dataIndex: "smallClassifyOperateStatusRemark"
  },
  {
    title: "状态",
    dataIndex: "operateStatusRemark"
  },
  {
    title: "状态标识",
    dataIndex: "operateStatus"
  },
  {
    title: "操作",
    dataIndex: "operateRemark"
  },
  {
    title: "操作标识",
    dataIndex: "operateType"
  },
  {
    title: "",
    scopedSlots: { customRender: "handleslot" }
  }
];
export default {
  data() {
    return {
      columns,
      data: [],
      confirmVisible: false,
      confirmLoadding: false,
      baseData: {},
      page: 1,
      pageSize: 10,
      selectData: null,
      visible: false,
      operateStatus: "",
      currentConfirmData: {
        title: "跟踪状态删除",
        content: "您确认删除这条数据么？",
        desc: "",
        operateType: "confirm-requisition"
      }
    };
  },
  components: { BaseDataAdd },
  mounted() {
    this.getList();
  },
  methods: {
    ckBaseDataModel() {
      this.selectData = null;
      this.visible = true;
    },
    editbaseModel(item) {
      this.selectData = item;
      this.visible = true;
    },
    closeModel() {
      this.visible = false;
    },
    pageChange(page, pagesize) {
      this.page = page;
      this.pageSize = pagesize;
      this.getList();
    },
    closeConfirm() {
      this.confirmVisible = false;
    },
    deleteBaseData(item) {
      this.confirmVisible = true;
      this.selectData = item;
    },
    okClick() {
      this.$delete("base/baseInfo", [this.selectData.id]).then(
        res => {
          if (res.data.code == 1) {
            this.confirmVisible = false;
            this.confirmLoadding = false;
            this.$message.success("删除数据成功");
          } else {
            this.confirmLoadding = false;
            this.$message.error(res.data.message);
          }
        },
        err => {
          this.confirmLoadding = false;
          this.$message.error("删除数据失败");
        }
      );
    },
    onSearch(value) {
      this.operateStatus = value;
      this.page = 1;
      this.getList();
    },
    getList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.page
      };
      if (this.operateStatus) {
        params.operateStatus = this.operateStatus;
      }
      this.$get("base/baseInfo", params).then(res => {
        this.baseData = res.data.data;
        this.data = res.data.data.rows;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.trun-role {
  .pagination {
    padding: 0 30px;
  }
}
</style>